import { render, staticRenderFns } from "./ModalEditNew.vue?vue&type=template&id=98e0fcc2&scoped=true"
import script from "./ModalEditNew.vue?vue&type=script&lang=js"
export * from "./ModalEditNew.vue?vue&type=script&lang=js"
import style0 from "./ModalEditNew.vue?vue&type=style&index=0&id=98e0fcc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e0fcc2",
  null
  
)

export default component.exports